import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {TrustedUrlPipe} from './trusted-url.pipe';
import {ImgAuthPipe} from '../auth/img-auth.pipe';

@NgModule({
  declarations: [
    TrustedUrlPipe,
    ImgAuthPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    TranslateModule,
    TrustedUrlPipe,
    ImgAuthPipe
  ]
})
export class SharedModule { }
